class ClipIn {
    constructor(parent, data) {
        this.parent = parent;
        this.data = data;
        window.addEventListener('page:ready', () => {
            this.run();
        })
    }
    run() {
        let listElements = document.querySelectorAll(".clip-in");

        const applyRevealClass = (element) => {
            if (!element.classList.contains("reveal")) {
                element.classList.add("reveal");
            }
        };

        const isElementOutOfViewport = (element) => {
            const bounding = element.getBoundingClientRect();
            return bounding.top + bounding.height < 0;
        };

        listElements.forEach(element => {
            if (isElementOutOfViewport(element)) {
                applyRevealClass(element);
            }
        });

        const handleScroll = () => {
            listElements.forEach(element => {
                const bounding = element.getBoundingClientRect();
                if (bounding.top < window.innerHeight - 10 && bounding.bottom > 0) {
                    applyRevealClass(element);
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        window.addEventListener('filter:change', function () {
            listElements = document.querySelectorAll(".clip-in");
            handleScroll();
        });
        handleScroll();
    }
}

export default ClipIn;
